module.exports = __webpack_public_path__ + "static/img/s4.619af140.png";